import * as actionTypes from '../constants/action-types';

export const setQuizAction = data => ({
  type: actionTypes.SET_QUIZ,
  data,
});
